import { Application } from '@hotwired/stimulus';
import Notification from '@stimulus-components/notification';
import { registerControllers } from 'stimulus-vite-helpers';
import '../../channels';

const application = Application.start();

application.register('notification', Notification);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
const compControllers = import.meta.glob('../../../views/components/**/*_controller.js', { eager: true });

registerControllers(application, controllers);
registerControllers(application, compControllers);
